import { DataSourceElement } from 'controls/designer/dataSourcesManager/dataSourceElement';
import State from 'tools/state';
import Utils from 'tools/utils';
import Settings from 'settings';
import { SlaRouter } from 'areas/sla/bundleDescription';
import { translator } from 'core/localization/localization';

const i18n = translator({
	'SLA: {0}': {
		no: 'SLA: {0}',
	},
});

export class SlaDataSourceElement extends DataSourceElement {
	slas = [];
	slaIds = [];
	indicators = {};

	constructor(designer, cell) {
		super(designer, cell);

		this.slaIds = this.datasource.slas;
	}

	getEntriesToLoad() {
		return this.slaIds.map((x) => ({
			slaId: x.id,
			accountId: x.accountId,
		}));
	}

	onHealthInfoLoaded(entries) {
		this.slas = entries;
	}

	updateState() {
		if (this.slas.length < this.slaIds.length) return;

		const aggregatedPriority = this.slas.reduce(
			(currentMin, x) => Math.min(indicatorToPriority(x.indicator), currentMin),
			100,
		);

		this.setState(PRIORITY_TO_STATE[aggregatedPriority]);
	}

	getSubscriptions(subscriptions) {
		return {
			slas: this.slaIds.map((x) => x.id),
		};
	}

	consumeEvent(event) {
		if (event.eventType != 'Sla')
			return {
				redraw: false,
				reload: false,
			};

		const sla = this.slas.find((x) => x.slaId == event.calculation.slaId);
		if (sla && sla.indicator != event.calculation.indicator) {
			sla.indicator = event.calculation.indicator;
			return {
				redraw: true,
				reload: false,
			};
		}

		return {
			redraw: false,
			reload: false,
		};
	}

	getTooltipInternal(accountName) {
		if (!this.slas?.length) return null;

		return i18n('SLA: {0}', this.slas.map((x) => x.slaName).join(', '));
	}

	redirect() {
		if (!this.slas?.length) {
			return;
		}

		var readUrl = Settings.serverPath + 'accounts/' + this.accountId + '/slas/' + this.slas[0].slaId + '/serviceId';
		Utils.ajax(
			readUrl,
			'GET',
			{},
			$.proxy(function (result) {
				if (result.success) {
					this.navigator.go({ url: SlaRouter.details(this.slas[0].slaId) });
				} else {
					Utils.showInfo(i18n('Alert'), result.message, result.details);
				}
			}, this),
		);
	}

	empty() {
		return this.slaIds.length == 0;
	}

	getLabel() {
		if (this.datasource.showAsLabel) {
			return this.slas[0]?.slaName;
		}

		return null;
	}
}

const INDICATOR_TO_PRIORITY = {
	OK: 3,
	WARNING: 2,
	FAILED: 1,
};

const PRIORITY_TO_STATE = ['INVALID', 'ERROR', 'WARNING', 'ACTIVE'];

function indicatorToPriority(indicator) {
	return INDICATOR_TO_PRIORITY[indicator] || 0;
}
